import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
 
const PurchaseModal = ({ showModal, setShowModal }) => {
   showModal = true;
  const handleClose = () => setShowModal(false);

  return (
    <>
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{ display: showModal ? "block" : "none" }}
        aria-labelledby="thankYouModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content text-center p-4">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close ms-auto"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">
              <img
                src="../assets/img/thankyou.png"
                alt="Thank You"
                className="thank-you-icon mb-3"
                style={{ width: "100px", height: "100px" }}
              />
              <h2 className="mb-3 text-success">Thank You!</h2>
              <p>Thank you for your recent purchase with us! We truly appreciate your trust in our products and are excited to serve you.</p>
              
            </div>
            <div className="modal-footer border-0 d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-primary px-4"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default PurchaseModal;
